import { Slide, SlideProps, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types'
import { ErrorToString } from "../../../logic/api";

const TransitionUp: React.FunctionComponent<SlideProps> = (props) => {
    return <Slide {...props} direction="up" />;
}

const SnackAlert: React.FunctionComponent<{
    onClose?: () => void,
    message?: string | unknown | null,
    id: string,
    autoHideDuration?: number | null,
    preventClose?: boolean,
    anchorOrigin?: { vertical: 'top' | 'bottom', horizontal: 'left' | 'center' | 'right' }
}> = (props) => {

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (props.message == null) {
            setOpen(false);
        } else {
            setOpen(true);
        }
    }, [props.id, props.message]);

    const message = typeof props.message === "string" ? props.message : ErrorToString(props.message);

    return <Snackbar
        autoHideDuration={props.autoHideDuration ?? 3000}
        anchorOrigin={props.anchorOrigin ?? { vertical: 'bottom', horizontal: 'center' }}
        open={open}
        onClose={() => {
            if (props.preventClose) {
                return;
            }

            setOpen(false);

            if (props.onClose) {
                props.onClose();
            }
        }}
        TransitionComponent={TransitionUp}
        message={message}
        key={props.id}
        test-id={`snackbar-${props.id}`}
        style={{ zIndex: 9999999 }}
    />;
};

SnackAlert.propTypes = {
    message: PropTypes.string,
    id: PropTypes.string.isRequired,
};

export { SnackAlert };